import React from 'react';

const Pay = () => {
    return (
        <div>
            <h2 className="text-center"><span style={{borderBottom:'2px solid #111868'}}>Payment System Comming Soon!</span></h2>
        </div>
    );
};

export default Pay;